import * as Yup from 'yup';
import {
  validateEmailFormat,
  validatePasswordForCreation,
} from 'utils/validation';
import { isPhoneComplete } from 'utils/countries';

const phoneNumberValidation = Yup.string().test(
  'phone-required',
  'Please fill out this field.',
  function (value) {
    const { whatsappNotifications, phoneCode } = this.parent;
    if (!whatsappNotifications) return true;
    if (!value || value.replace(/\D/g, '').length === 0) return false;
    return isPhoneComplete(value, phoneCode);
  },
);

export const validationSchemaCreateStepOne = Yup.object({
  fullname: Yup.string().test(
    'required',
    'Please fill out this field.',
    (value) => {
      return value !== undefined && value !== null && value.trim().length > 0;
    },
  ),
  email: Yup.string()
    .test('required', 'Please fill out this field.', (value) => {
      return value !== undefined && value !== null && value.trim().length > 0;
    })
    .test('email-format', 'Invalid email format.', (value) => {
      if (!value || value.trim().length === 0) return true;
      return validateEmailFormat(value);
    }),
  password: Yup.string()
    .test('required', 'Please fill out this field.', (value) => {
      return value !== undefined && value !== null && value.length > 0;
    })
    .test(
      'password-strength',
      'Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.',
      (value) => {
        if (!value || value.length === 0) return true;
        return validatePasswordForCreation(value);
      },
    ),
  phoneNumber: phoneNumberValidation,
});

export const validationSchemaEditStepOne = Yup.object().shape({
  fullname: Yup.string()
    .required('Full name is required')
    .min(1, 'Full name must be at least 1 character')
    .max(100, 'Full name must be less than 100 characters'),

  email: Yup.string()
    .required('Email is required')
    .email('Invalid email format')
    .max(256, 'Email must be less than 256 characters'),

  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(64, 'Password must be less than 64 characters')
    .notRequired(),

  phoneNumber: phoneNumberValidation,
});
